import React from 'react';
import styled, { css } from 'styled-components';
import ChevronSVG from 'images/svg/chevron-right.svg';

const CarouselBtnContainer = styled.div`
  display: grid;
  grid-gap: 1.6rem;
  grid-auto-flow: column;
  align-items: center;
  height: max-content;
  max-width: max-content;
`;

const NextArrow = styled(ChevronSVG)`
  cursor: pointer;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    height: 2.4rem;
    width: 2.4rem;
  }
`;

const PrevArrow = styled(NextArrow)`
  transform: rotate(180deg);
`;

const Dot = styled.div`
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 50%;
  transition: all 0.1s;

  ${({ isCurrent }) =>
    isCurrent
      ? css`
          background: ${({ theme }) => theme.palette.blackLighten5};
        `
      : css`
          background: ${({ theme }) => theme.palette.grayLighten10};
        `}

  ${({ theme }) => theme.breakpoints.maxTablet} {
    height: 0.6rem;
    width: 0.6rem;
  }
`;

const CarouselButtons = ({ itemCount, currentPosition, prevHandler, nextHandler }) => (
  <CarouselBtnContainer>
    <PrevArrow onClick={prevHandler} />
    {Array.from({ length: itemCount }, (item, index) => (
      <Dot key={index} isCurrent={index === currentPosition} />
    ))}
    <NextArrow onClick={nextHandler} />
  </CarouselBtnContainer>
);

export default CarouselButtons;
